import { StrictMode, useSyncExternalStore } from 'react';
import { createRoot } from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import { DatesProvider } from '@mantine/dates';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import 'dayjs/locale/ru';
import 'dayjs/locale/zh-cn';
import '@fontsource-variable/golos-text';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import './global.css';
import { theme } from './theme';
import { getSettings, subscribeSettings } from './settings';
import { loadMe, useAuth } from './auth';
import { LoginScreen } from './screens/login/LoginScreen';
import { Center, Loader } from '@mantine/core';
import { App } from './App';
import { useLang } from './i18n';

const DATE_LOCALE = { ru: 'ru', en: 'en', zh: 'zh-cn' } as const;

const root = document.getElementById('root');
if (!root) throw new Error('Нет элемента #root в index.html');

/** Тема и язык берутся из настроек пользователя и переключаются без перезагрузки. */
function Root() {
  const settings = useSyncExternalStore(subscribeSettings, getSettings);
  const lang = useLang();
  const auth = useAuth();
  return (
    <MantineProvider theme={theme} forceColorScheme={settings.theme}>
      <DatesProvider settings={{ locale: DATE_LOCALE[lang], firstDayOfWeek: 1 }}>
        <ModalsProvider>
          <Notifications position="bottom-right" autoClose={4000} limit={3} />
          {!auth.checked ? (
            <Center h="100vh">
              <Loader />
            </Center>
          ) : auth.user ? (
            <App />
          ) : (
            <LoginScreen />
          )}
        </ModalsProvider>
      </DatesProvider>
    </MantineProvider>
  );
}

// Сначала — кто вошёл и его настройки (тема, ширины столбцов), потом интерфейс или экран входа
void loadMe().finally(() => {
  createRoot(root).render(
    <StrictMode>
      <Root />
    </StrictMode>
  );
});
